// extracted by mini-css-extract-plugin
export default {"link":"BracketLink_link__SfTSG","bracket":"BracketLink_bracket__AeX79","active":"BracketLink_active__vGP4V"};